export interface PoseInput {
    heading: number;
    speed: number;
    pedalling: boolean;
    skidding: boolean;
    time: number;
}

export interface Pose {
    pose: string;
    flipX: boolean;
}

export function headingPose(heading: number): string {
    const angle = Math.abs(heading);
    if (angle >= 75) return "left90";
    if (angle >= 45) return "left60";
    if (angle >= 15) return "left30";
    return "down";
}

const cadence = (speed: number) => 2 + speed / 5;

/** True when the steering input points the same way as the bike's heading (key held or stick pushed out). */
export function pushingSideways(heading: number, steer: number, targetHeading: number | null): boolean {
    const side = Math.sign(heading);
    if (side === 0) return false;
    if (Math.sign(steer) === side) return true;
    return targetHeading !== null && Math.sign(targetHeading) === side && headingPose(targetHeading) === "left90";
}

/**
 * The fully side-on pose has no pedal frames, so pedalling across the slope rocks the bike a few
 * degrees to the cadence - but only while the rider is actively pushing sideways.
 */
export function pedalRock({ heading, speed, pedalling, skidding, time }: PoseInput, pushing: boolean): number {
    if (!pedalling || skidding || !pushing || headingPose(heading) !== "left90") return 0;
    return Math.sin(time * cadence(speed) * Math.PI) * 4;
}

export function riderPose({ heading, speed, pedalling, skidding, time }: PoseInput): Pose {
    if (skidding) return { pose: "skid", flipX: heading > 0 };

    const pose = headingPose(heading);
    if (pedalling && pose === "down") {
        return { pose: Math.floor(time * cadence(speed)) % 2 ? "pedal_b" : "pedal_a", flipX: false };
    }
    return { pose, flipX: heading >= 15 };
}
